import React, { useEffect, useState } from "react";
import StyledFirebaseAuth from "react-firebaseui/StyledFirebaseAuth";
import firebase from "../fbConfig";
import StaticHeader from "../StaticHeader/StaticHeader";
import axios from "axios";

//firebase deploy --only hosting

const uiConfig = {
  // Popup signin flow rather than redirect flow.
  signInFlow: "popup",
  // We will display Google and Facebook as auth providers.
  signInOptions: [
    // {
    //   provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
    //   recaptchaParameters: {
    //     size: "invisible",
    //   },
    //   defaultCountry: "IN",
    //   whitelistedCountries: ["IN"],
    // },
    {
      provider: firebase.auth.GoogleAuthProvider.PROVIDER_ID,
      customParameters: {
        // Forces account selection even when one account
        // is available.
        prompt: "select_account",
      },
    },
  ],
  callbacks: {
    signInSuccessWithAuthResult: () => false,
  },
};

const getData = async (domain, url, keyid, method = "GET", data = "") => {
  var dt = new Date();
  const timestamp = dt.getTime();
  var headers = {
    "X-TimeStamp": timestamp,
    "X-DateTime": dt.toUTCString(),
    "X-AUTH-TOKEN": keyid,
  };
  if (method === "GET") {
    return await axios.get(domain + url + "?timestamp=" + timestamp, {
      headers: headers,
    });
  } else {
    headers["Content-Type"] = "application/json";
    return await axios.post(domain + url + "?timestamp=" + timestamp, data, {
      headers: headers,
    });
  }
};
export const SignIn = (props) => {
  const { match } = props;
  const { params } = match || {};
  const { keyid } = params || {};
  const { hostname } = window.location;
  const [firebaseUser, setFirebaseUser] = useState(null);
  const [showLogin, setShowLogin] = useState(false);
  const [isError, setIserror] = useState(false);
  const [authInfo, setAuthInfo] = useState({});
  const [showLoading, setShowLoading] = useState(true);

  const CurrentDomain =
    hostname.toLowerCase().indexOf("mybillees.com") === -1
      ? "https://oauthcheck.billees.com"
      : "https://oauthcheck.mybillees.com";

  //const apihost = CurrentDomain;
  const apihost =
    process.env.NODE_ENV === "production"
      ? CurrentDomain
      : "http://localhost:5000";

  const updateAndRedirect = (user) => {
    const uid = {
      uid: user.uid,
    };

    getData(
      apihost,
      "/oauth/updateinfo/" + keyid,
      keyid,
      "POST",
      JSON.stringify(uid)
    )
      .then((res) => {
        //console.log("Update res:", res);
        setShowLoading(false);
        if (res.data.status === "success") {
          const { domain } = authInfo;
          if (domain != null) {
            window.location.href = domain;
          }
        } else {
          setIserror(true);
        }
      })
      .catch((error) => {
        //console.log("Update Info Error:", error);
      });
  };

  useEffect(() => {
    if (keyid == null || keyid === "") return;
    getData(apihost, "/oauth/getinfo/" + keyid, keyid)
      .then((res) => {
        if (res.data.status === "success") {
          const data = JSON.parse(res.data.data);
          setAuthInfo(data);
        } else {
          setIserror(true);
        }
      })
      .catch((error) => {
        setIserror(true);
      });
  }, []);

  useEffect(() => {
    //console.log("authInfo", authInfo);
    if (authInfo.domain == null) return;
    firebase.auth().onAuthStateChanged((user) => {
      //console.log("Firebase user:", user);
      setFirebaseUser(user);
      if (user != null && user.uid != null) {
        updateAndRedirect(user);
        setShowLogin(false);
      } else {
        setShowLogin(true);
        setShowLoading(false);
      }
    });
  }, [authInfo]);

  if (keyid == null || keyid === "" || isError === true) {
    window.location.href = "http://billees.com";
    //console.log("Error");
  }

  if (showLoading === true) {
    return (
      <div className="App">
        <div className="sign-in">
          <StaticHeader data={authInfo} />
          <div className="loading-dialog-container">
            <div className="loading-dialog-empty"></div>
            <div className="loading-dialog-loading">
              <div className="loading-dialog-circle"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <div className="sign-in">
        <>
          <StaticHeader data={authInfo} />
          {firebaseUser == null && showLogin && (
            <div className="sign-in-container">
              <StyledFirebaseAuth
                uiConfig={uiConfig}
                firebaseAuth={firebase.auth()}
              ></StyledFirebaseAuth>
            </div>
          )}
        </>
      </div>
    </div>
  );
};

export default SignIn;
